import { motion } from "framer-motion";
import { Compass, Eye } from "lucide-react";

export default function MissionVision() {
  return (
    <section id="mission" className="relative overflow-hidden bg-white py-20 md:py-4">
      <div className="pointer-events-none absolute left-0 top-1/2 h-96 w-96 -translate-x-1/2 -translate-y-1/2 rounded-full bg-[#DA2128]/5" />

      <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="mb-12 text-center md:mb-16">
          {/* <motion.span
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            className="mb-3 inline-block text-xs font-bold tracking-[0.2em] text-[#DA2128] uppercase"
          >
            Purpose Driven
          </motion.span> */}
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="font-serif text-4xl font-medium leading-tight tracking-tight sm:text-3xl lg:text-4xl"
          >
            Mission & {" "}
            <motion.span 
                className="italic text-[#DA2128]"
                initial={{ opacity: 0, x: -20 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: 0.3 }}
              >
            Vision
            </motion.span>
          </motion.h2>
          <div className="mx-auto mt-4 accent-bar" />
        </div>

        <div className="grid gap-8 md:grid-cols-2">
          {/* Mission */}
          <motion.div
            initial={{ opacity: 0, x: -40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="group relative overflow-hidden rounded-3xl bg-[#DA2128] p-8 text-white shadow-2xl shadow-[#DA2128]/30 md:p-10"
          >
            <div className="pointer-events-none absolute -right-8 -top-8 h-40 w-40 rounded-full bg-white/10 transition-transform duration-500 group-hover:scale-125" />
            <div className="pointer-events-none absolute -bottom-10 -left-10 h-48 w-48 rounded-full bg-white/5" />

            <div className="relative">
              <div className="mb-6 flex h-16 w-16 items-center justify-center rounded-2xl bg-white/20 backdrop-blur-sm transition-transform duration-300 group-hover:scale-110 group-hover:rotate-3">
                <Compass size={32} />
              </div>
              <p className="mb-2 text-xs font-bold tracking-[0.2em] text-white/70 uppercase">
                Our Mission
              </p>
              <h3 className="mb-5 text-2xl font-bold md:text-3xl">
                Enabling Business in India
              </h3>
              <p className="text-base leading-relaxed text-white/90 md:text-lg">
                To contribute through policies and programmes for enabling
                business in India.
              </p>

              <div className="mt-8 flex items-center gap-3">
                <div className="h-1 w-12 rounded-full bg-white/40" />
                <div className="h-1 w-6 rounded-full bg-white/20" />
                <div className="h-1 w-3 rounded-full bg-white/10" />
              </div>
            </div>
          </motion.div>

          {/* Vision */}
          <motion.div
            initial={{ opacity: 0, x: 40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.15 }}
            className="group relative overflow-hidden rounded-3xl border-2 border-gray-100 bg-[#FAF7F2] p-8 shadow-xl md:p-10"
          >
            <div className="pointer-events-none absolute -right-8 -top-8 h-40 w-40 rounded-full bg-[#DA2128]/5 transition-transform duration-500 group-hover:scale-125" />

            <div className="relative">
              <div className="mb-6 flex h-16 w-16 items-center justify-center rounded-2xl bg-[#DA2128] text-white shadow-lg shadow-[#DA2128]/30 transition-transform duration-300 group-hover:scale-110 group-hover:-rotate-3">
                <Eye size={32} />
              </div>
              <p className="mb-2 text-xs font-bold tracking-[0.2em] text-[#DA2128] uppercase">
                Our Vision
              </p>
              <h3 className="mb-5 text-2xl font-bold text-gray-900 md:text-3xl">
                Knowledge as Catalyst
              </h3>
              <p className="text-base leading-relaxed text-gray-600 md:text-lg">
                ASSOCHAM aims to empower stakeholders by promoting knowledge as
                the catalyst for growth in a dynamic global environment.
              </p>

              <div className="mt-8 flex items-center gap-3">
                <div className="h-1 w-12 rounded-full bg-[#DA2128]/40" />
                <div className="h-1 w-6 rounded-full bg-[#DA2128]/20" />
                <div className="h-1 w-3 rounded-full bg-[#DA2128]/10" />
              </div>
            </div>
          </motion.div>
        </div>

        {/* Supporting image strip */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="mt-12 overflow-hidden rounded-3xl"
        >
          {/* <div className="relative h-48 sm:h-64 md:h-72">
            <img
              src="https://images.pexels.com/photos/7580648/pexels-photo-7580648.jpeg?auto=compress&cs=tinysrgb&fit=crop&h=600&w=1400"
              alt="ASSOCHAM vision - collaborative growth"
              className="h-full w-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-[#DA2128]/90 via-[#DA2128]/60 to-transparent" />
            <div className="absolute inset-0 flex items-center">
              <div className="max-w-lg px-8 md:px-12">
                <p className="text-xl font-bold text-white sm:text-2xl md:text-3xl">
                  Building a developed and future-ready India
                </p>
                <p className="mt-2 text-sm text-white/85 sm:text-base">
                  Strengthening a robust network of knowledge architects to
                  redefine growth in a technology-driven economy.
                </p>
              </div>
            </div>
          </div> */}
        </motion.div>
      </div>
    </section>
  );
}
